module.exports = __webpack_public_path__ + "media/images/subject_img/CHEMICAL ENGINEERING-97eb893aac0a1ca6641edeb49191aeb0.jpg";